import React from 'react';
import { BadgeCheck } from 'lucide-react';

const HeroContent = () => {
    return (
        <div className="max-w-xl flex flex-col gap-8 pt-10 md:pt-20 items-center md:items-start text-center md:text-left">
            {/* Headline */}
            <h1 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.1] text-slate-900">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-blue-400 to-blue-800 drop-shadow-sm">
                    Your AI
                </span> <br />
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-700 via-blue-500 to-blue-400 drop-shadow-md">
                    Customer <br /> Support
                </span> <br />
                <span className="text-slate-800 font-bold">For Business</span>
            </h1>

            {/* Description */}
            <p className="text-base text-slate-500 max-w-md leading-relaxed">
                Empower your business with an AI-driven support system that handles inquiries, syncs data across platforms, and automates workflows seamlessly.
            </p>

            {/* META Verified Tag */}
            <div className="flex flex-col gap-6">
                <div className="w-fit flex items-center gap-2.5 bg-white border border-blue-100 px-4 py-2 rounded-full shadow-sm hover:shadow-md transition-all">
                    <img
                        src="/meta.png"
                        alt="Meta"
                        className="w-6 h-6 object-contain"
                    />
                    <span className="text-sm font-bold text-slate-800 tracking-tight">
                        META Verified
                    </span>
                    <BadgeCheck className="w-4 h-4 text-blue-600" />
                </div>
            </div>
        </div>
    );
};

export default HeroContent;
